import { InfoOutlined } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import { AssortmentTag } from '@retail/my-assortment/types';
import { useProductsTFunction } from '@retail/products/i18n';
import { getLLDate } from '@retail/utils';

interface Props {
  assortmentTag: AssortmentTag;
}

export function TagDateRangeInfo({ assortmentTag }: Props) {
  const t = useProductsTFunction();
  return (
    <Stack flexDirection="row" alignItems="flex-start" gap={1}>
      <InfoOutlined fontSize="small" />
      <Stack>
        <Stack flexDirection="row" alignItems="center" gap={0.5}>
          <Typography>
            {t('products.mgItem.dateRange', {
              assortment: assortmentTag.name,
            })}
          </Typography>
          <Typography>{`${getLLDate(assortmentTag.validFrom)} - ${
            getLLDate(assortmentTag.validTo) ?? '->'
          }`}</Typography>
        </Stack>
        <Typography variant="body2">{t('products.mgItem.dateRangeLimited')}</Typography>
      </Stack>
    </Stack>
  );
}
